export const USER_DATA = 'USER_DATA';
export const CART_DATA = 'CART_DATA';
export const USER_LOGOUT = 'USER_LOGOUT';
